import React from 'react';
import ReactPlaceholder from 'react-placeholder';

const ShippingLoader = () => {
  return (
    <div className="shipping-loader">
      <ReactPlaceholder
        showLoadingAnimation
        color="#f5f5f5"
        type="rect"
        style={{ width: 32, height: 32 }}
      />
      <ReactPlaceholder
        showLoadingAnimation
        color="#f5f5f5"
        type="text"
        rows={4}
        style={{ width: 256, height: 64 }}
      />
    </div>
  );
};

export default ShippingLoader;
